import React from "react";

const faqs = [
  { q: "Wie schnell bekomme ich einen Termin?", a: "Oft innerhalb von 24–72 Stunden, je nach Auslastung." },
  { q: "Ist mein Umzug versichert?", a: "Ja, nach Vereinbarung ist Ihr Umzugsgut versichert." },
 /* { q: "Bietet ihr Halteverbotszonen an?", a: "Auf Wunsch kümmern wir uns um die Einrichtung einer Halteverbotszone." },*/
];

export default function FAQ() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-white">
      <div className="max-w-[1100px] mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold">Häufige Fragen</h2>
        <div className="mt-6 space-y-3">
          {faqs.map((f) => (
            <details key={f.q} className="rounded-2xl p-5 shadow-[0_10px_25px_rgba(2,6,23,.06)]">
              <summary className="cursor-pointer font-semibold">{f.q}</summary>
              <p className="mt-2 text-sm text-slate-600">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
